export default function ReasonsSection() {
  const reasons = [
    {
      number: '01',
      icon: 'ri-link',
      title: 'EC×SNSの相乗効果',
      description:
        '認知(SNS)から成約(EC)まで。分断されがちな施策を統合し、最大の結果を出します。',
    },
    {
      number: '02',
      icon: 'ri-time-line',
      title: '6カ月での内製化コミット',
      description:
        '「教える」だけでなく「仕組み化」まで。半年後には貴社だけで運用できる体制を目指します。',
    },
    {
      number: '03',
      icon: 'ri-shield-check-line',
      title: '公的な信頼と経営知見',
      description:
        'デジタル推進委員としての公的知見に基づき、高効率なDX投資を実現します。',
    },
  ];

  return (
    <section id="why-choose-us" className="py-16 sm:py-24 md:py-32 bg-[#f8f9fa]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-10 sm:mb-14 md:mb-18">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#333333] mb-4">
            Naturiが選ばれる3つの理由
          </h2>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 p-4 sm:p-6 space-y-4"
            >
              <div className="flex justify-center">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#27ae60]">
                  <span className="text-lg sm:text-xl text-white">{reason.number}</span>
                </div>
              </div>

              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#e8f5e9] mx-auto rounded-full">
                <i className={`${reason.icon} text-xl sm:text-2xl text-[#27ae60]`}></i>
              </div>

              <h3 className="text-base sm:text-lg text-[#333333] text-center">{reason.title}</h3>

              <p className="text-[0.8rem] sm:text-sm md:text-base text-[#333333] leading-[1.7] text-center">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
